import { Button } from "@/components/ui/Button";
import * as shared from "@/styles/shared";
import { Building2 } from "lucide-react";
import { styles } from "../AddressesPage.styles";
import { useAddresses } from "./AddressesContext";

const AssignProviderDialog = () => {
  const ctx = useAddresses();

  const patchAssign = (partial: Partial<typeof ctx.assignState>) => ctx.setState({ assignState: { ...ctx.assignState, ...partial } });
  const close = () => patchAssign({ open: false });
  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) close();
  };
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Escape") close();
  };

  if (!ctx.assignState.open) return null;

  return (
    <div className={shared.dialogOverlay} onClick={handleOverlayClick} onKeyDown={handleKeyDown}>
      <div className={shared.dialog}>
        <div className={styles.dialogHeader}>
          <Building2 className={styles.dialogIcon} />
          <h2 className={shared.headingLg}>{ctx.t("addresses:assignProvider")}</h2>
        </div>
        <div className={styles.dialogBody}>
          <div className={shared.formStack}>
            <label className={styles.formLabel}>{ctx.t("addresses:selectProvider")}</label>
            <select value={ctx.assignState.providerId} onChange={(e) => patchAssign({ providerId: e.target.value })} className={shared.inputBase}>
              <option value="">{ctx.t("addresses:selectProvider")}</option>
              {ctx.allProviders.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.name}
                </option>
              ))}
            </select>
            <label className={styles.formLabel}>{ctx.t("placeholder.username")}</label>
            <input
              value={ctx.assignState.username}
              onChange={(e) => patchAssign({ username: e.target.value })}
              placeholder={ctx.t("placeholder.username")}
              className={shared.inputBase}
            />
            <label className={styles.formLabel}>{ctx.t("common:label.password")}</label>
            <input
              value={ctx.assignState.password}
              onChange={(e) => patchAssign({ password: e.target.value })}
              placeholder={ctx.t("placeholder.password")}
              type="password"
              autoComplete="off"
              className={shared.inputBase}
            />
            <label className={styles.formLabel}>{ctx.t("common:label.accountKeyword")}</label>
            <input
              value={ctx.assignState.accountKeyword}
              onChange={(e) => patchAssign({ accountKeyword: e.target.value })}
              placeholder={ctx.t("addresses:placeholder.accountKeyword")}
              className={shared.inputBase}
            />
            <label className={styles.checkboxLabel}>
              <input type="checkbox" checked={ctx.assignState.skipPayment} onChange={(e) => patchAssign({ skipPayment: e.target.checked })} />{" "}
              {ctx.t("addresses:label.skipPayment")}
            </label>
            <label className={styles.checkboxLabel}>
              <input
                type="checkbox"
                checked={ctx.assignState.meterReadingEnabled}
                onChange={(e) => patchAssign({ meterReadingEnabled: e.target.checked })}
              />{" "}
              {ctx.t("addresses:label.meterReadingEnabled")}
            </label>
            <label className={styles.checkboxLabel}>
              <input type="checkbox" checked={ctx.assignState.taxDeduction} onChange={(e) => patchAssign({ taxDeduction: e.target.checked })} />{" "}
              {ctx.t("addresses:label.taxDeduction")}
            </label>
            {ctx.assignState.taxDeduction && (
              <input
                value={ctx.assignState.taxDeductionAmount}
                onChange={(e) => patchAssign({ taxDeductionAmount: e.target.value })}
                placeholder={ctx.t("placeholder.taxDeductionAmount")}
                type="number"
                step="0.01"
                min="0"
                className={shared.inputBase}
              />
            )}
            <label className={styles.formLabel}>{ctx.t("addresses:label.invoiceEmailTo")}</label>
            <input
              value={ctx.assignState.invoiceEmailTo}
              onChange={(e) => patchAssign({ invoiceEmailTo: e.target.value })}
              placeholder={ctx.t("addresses:placeholder.invoiceEmailTo")}
              type="email"
              autoComplete="off"
              className={shared.inputBase}
            />
          </div>
          <div className={styles.buttonGroup}>
            <Button variant="secondary" onClick={close}>
              {ctx.t("addresses:cancel")}
            </Button>
            <Button variant="gradient" onClick={ctx.handleAssign}>
              {ctx.t("addresses:assign")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export { AssignProviderDialog };
